import * as Sentry from "@sentry/react";
import { Route } from "react-router-dom";

import type { History } from "history";

function sentrySanitizeUrl(url: string | undefined) {
  return String(url).replace(/https?:\/\//, "");
}

export const SentryRoute = Sentry.withSentryRouting(Route);

export function sentryConfig(
  environment: string,
  history: History<unknown>
): Sentry.BrowserOptions {
  return {
    dsn: process.env.REACT_APP_SENTRY_URL,
    replaysSessionSampleRate: 0.0,
    replaysOnErrorSampleRate: 1.0,
    integrations:
      process.env.REACT_APP_ENV === "rc"
        ? []
        : [
            new Sentry.BrowserTracing({
              // do not add api domains that do not allow CORS headers: "sentry-trace", "baggage"
              tracePropagationTargets: [
                sentrySanitizeUrl(process.env.REACT_APP_API_URL),
                sentrySanitizeUrl(process.env.REACT_APP_NOTIFICATIONS_MAIN_URL),
              ],
              routingInstrumentation: Sentry.reactRouterV5Instrumentation(
                history
              ),
              shouldCreateSpanForRequest: (url) => {
                return (
                  Boolean(url.match(/\/payments([^/]+|$)/)) ||
                  Boolean(url.match(/\/customers\?/)) ||
                  Boolean(
                    url.match(/\/payments\/clients\/[^/]+\/outstanding$/)
                  ) ||
                  Boolean(
                    url.match(/\/clients\/[^/]+\/notifications\/settings$/)
                  ) ||
                  Boolean(url.match(/\/clients\/[^/]+$/))
                );
              },
              idleTimeout: 2000,
              beforeNavigate: (context) => {
                return {
                  ...context,
                  name: window.location.pathname
                    .replace(
                      /\/\b[0-9a-f]{8}\b-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-\b[0-9a-f]{12}\b/g,
                      "/<uuid>"
                    )
                    .replace(/(\/reset-password\/)[^/|$]+/g, "$1<token>"),
                };
              },
            }),
            new Sentry.Replay({
              maskAllText: true,
              blockAllMedia: true,
              maskAllInputs: true,
            }),
          ],
    environment,
    tracesSampler: (samplingContext) => {
      if (
        samplingContext.location?.pathname.match(/^\/transactions$/) ||
        samplingContext.location?.pathname.match(
          /^\/configuration\/applications\/[^/]+\/payment-notifications$/
        )
      ) {
        return 1.0;
      }

      return 0.0;
    },
  };
}
